import tippy from 'tippy.js'

export default {
    install: (app, options) => {
        app.config.globalProperties.$tippy = (selector, props) => tippy(selector, props)

        app.provide('tippy', options)
    }
}
